import React from "react";

export const loaderViewNew = () => {
  return (
    <div>
      <div className="loaderText text-center">
        Please wait while code is getting generated. This may take a few minutes
      </div>
      <div className="loader">
        {/* <svg version="1.0" width="64px" height="64px" viewBox="0 0 128 128">
        <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" />
        <circle cx="64.13" cy="64.13" r="27.63" fill="#000000" />
        <path
          d="M64.13 18.5A45.63 45.63 0 1 1 18.5 64.13 45.63 45.63 0 0 1 64.13 18.5zm0 7.85a37.78 37.78 0 1 1-37.78 37.78 37.78 37.78 0 0 1 37.78-37.78z"
          fill-rule="evenodd"
          fill="#000000"
        />
        <g>
          <path
            d="M95.25 17.4a56.26 56.26 0 0 0-76.8 13.23L12.1 26.2a64 64 0 0 1 87.6-15.17z"
            fill="#000000"
          />
          <path
            d="M95.25 17.4a56.26 56.26 0 0 0-76.8 13.23L12.1 26.2a64 64 0 0 1 87.6-15.17z"
            fill="#000000"
            transform="rotate(120 64 64)"
          />
          <path
            d="M95.25 17.4a56.26 56.26 0 0 0-76.8 13.23L12.1 26.2a64 64 0 0 1 87.6-15.17z"
            fill="#000000"
            transform="rotate(240 64 64)"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 64 64"
            to="120 64 64"
            dur="1080ms"
            repeatCount="indefinite"
          ></animateTransform>
        </g>
      </svg> */}
        <svg version="1.0" width="150px" height="100px" viewBox="0 0 300 150">
          <path
            fill="none"
            stroke="#681c5c"
            strokeWidth="14"
            strokeLinecap="round"
            strokeDasharray="300 385"
            strokeDashoffset="0"
            d="M275 75c0 31-27 50-50 50-58 0-92-100-150-100-28 0-50 22-50 50s23 50 50 50c58 0 92-100 150-100 24 0 50 19 50 50Z"
          >
            <animate
              attributeName="stroke-dashoffset"
              calcMode="spline"
              dur="2"
              values="685;-685"
              keySplines="0 0 1 1"
              repeatCount="indefinite"
            ></animate>
          </path>
        </svg>
      </div>
    </div>
  );
};
